import React from 'react'
import EditableComponent from './EditableComponent'
import getEnumTranslation from '@/enums/enums'
import { DropDownList } from '@/components/dropDownList'
import { VALUES as SnapshotDateQuarterlyValues } from '@/enums/SnapshotDateQuarterly'
import { VALUES as DueDateQuarterlyValues } from '@/enums/DueDateQuarterly'

import OffsetInput from './OffsetInput'
import { Col, Row } from 'reactstrap'

class QuarterlyDatePicker extends EditableComponent {
  renderDropDownList (data) {
    return (<DropDownList
      disabled={this.props.disabled}
      data={data}
      onChange={({ value }) => this.props.onIntValueChange(value)}
      value={this.props.intValue}
      textField='text'
      valueField='value' />)
  }
  renderControl () {
    const { localize, disabled } = this.props
    const enumName = this.props.isDueDate ? 'DueDateQuarterly' : 'SnapshotDateQuarterly'
    const values = this.props.isDueDate ? DueDateQuarterlyValues : SnapshotDateQuarterlyValues
    if (this.isEdited()) {
      const data = values.map(x => ({ text: getEnumTranslation({ localize, enumName, value: x }), value: x }))

      return (<Row className='f1'>
        <Col sm='6'>{this.renderDropDownList(data)}</Col>
        <Col sm='6'><OffsetInput disabled={disabled} value={this.props.offset} onChange={offset => this.props.onOffsetChange(offset)} /></Col>
      </Row>)
    }
    const text = getEnumTranslation({ localize, enumName, value: this.props.intValue })
    return this.renderReadOnlyText(text.replace('#', this.props.offset))
  }
}

export default QuarterlyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/QuarterlyDatePicker.js